export enum TaskStatusNames {
    OPEN = 'Open',
    CLOSED = 'Closed',
}
